/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelForm64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelForm64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g opacity="0.1">
            <path
              d="M50 29C51.1046 29 52 29.8954 52 31V35C52 36.1046 51.1046 37 50 37H14C12.8954 37 12 36.1046 12 35V31C12 29.8954 12.8954 29 14 29H50Z"
              fill="currentColor"
            />
            <path
              d="M50 17C51.1046 17 52 17.8954 52 19V23C52 24.1046 51.1046 25 50 25H14C12.8954 25 12 24.1046 12 23V19C12 17.8954 12.8954 17 14 17H50Z"
              fill="currentColor"
            />
          </g>
          <g>
            <path
              d="M30 41C31.1046 41 32 41.8954 32 43V45C32 46.1046 31.1046 47 30 47H14C12.8954 47 12 46.1046 12 45V43C12 41.8954 12.8954 41 14 41H30Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M50 29C51.1046 29 52 29.8954 52 31V35C52 36.1046 51.1046 37 50 37H14C12.8954 37 12 36.1046 12 35V31C12 29.8954 12.8954 29 14 29H50ZM14 30C13.4477 30 13 30.4477 13 31V35C13 35.5523 13.4477 36 14 36H50C50.5523 36 51 35.5523 51 35V31C51 30.4477 50.5523 30 50 30H14Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M50 17C51.1046 17 52 17.8954 52 19V23C52 24.1046 51.1046 25 50 25H14C12.8954 25 12 24.1046 12 23V19C12 17.8954 12.8954 17 14 17H50ZM14 18C13.4477 18 13 18.4477 13 19V23C13 23.5523 13.4477 24 14 24H50C50.5523 24 51 23.5523 51 23V19C51 18.4477 50.5523 18 50 18H14Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelForm64Icon.tags = ['add', 'form', 'menu', 'list', 'interface'];

AddPanelForm64Icon.category = '64x64 (Add panel)';

AddPanelForm64Icon.iconSize = 64;
